<template>
    <div>
        <el-input
            v-if="mode == 'edit'"
            :ref="reference"
            :placeholder="prop.defaultValue" 
            v-model="currentValue"
            :minlength="parseInt(prop.min)"
            :maxlength="parseInt(prop.max)">
        </el-input>
        <p v-else>
            {{currentValue}}
        </p>
    </div>
</template>

<script>
    import CfMixin from '../../../mixins/CustomfieldInputsMixins'
    export default {
        mixins: [CfMixin],

        data(){
            return {
                localValue : this.value,
                currentValue: ''
            }
        },

        methods: {
            checkParams(newValue) {
                let valid = true
                valid = this.checkMinMaxParams(newValue)
                return valid
            }
        },

        created(){
            if(!this.localValue){
                this.localValue = JSON.parse(JSON.stringify(this.templateData))
                this.currentValue = this.prop.defaultValue
            } else{
                this.currentValue = this.value.textValue
            }
        },

        watch: {
            currentValue(newValue) {
                // if (this.checkParams(newValue)) {
                    this.$emit('input', {...this.localValue, ['textValue'] : newValue})
                // }
            },
            value : {
                handler: function (newValue) { 
                    this.localValue = newValue
                    this.currentValue = newValue.textValue
                },
                deep: true
            }
        }
    }
</script>
